enum Report {
    None = 0,
    Game1_Width = 1 << 0,
    Game1_Placement = 1 << 1,
    Game2_Angle = 1 << 2,
    Game2_NumberOfCones = 1 << 3,
    Game3_Timing = 1 << 4,
    Game3_Route = 1 << 5
}

export default Report;

const RawReports = Object.values(Report);
export const ReportValues = <Report[]>Object.keys(Report).map(Number).filter(Boolean);
export const ReportStrings = ReportValues.map((value:Report) => Report[value]);